import SectionWrapper from "./SectionWrapper";
import EscalationMatrixTable from "./EscalationMatrixTable";
import ManagerialDetailsTable from "./ManagerialDetailsTable";
import { Grid2 } from "@mui/material";

const WebView = () => {
  return (
    <>
      <Grid2 sx={{
        padding: "20px 0px",
        background:
          "linear-gradient(252.52deg, #110A0A 9.37%, #2D1F1C 47.3%, #2F2F0A 73.59%, #171346 99.03%)",
        overflow: "hidden",
        boxSizing: "border-box",
        backgroundSize: "400% 400%",
        animation: "gradientMove 6s ease infinite",
        "@keyframes gradientMove": {
          "0%": {
            backgroundPosition: "0% 50%",
          },
          "50%": {
            backgroundPosition: "100% 50%",
          },
          "100%": {
            backgroundPosition: "0% 50%",
          },
        }
      }} >


      <SectionWrapper >
        <EscalationMatrixTable />
      </SectionWrapper>


        <ManagerialDetailsTable />
      </Grid2>
    </>
  );
};

export default WebView;
